/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { RESERVE_TYPES } from 'constants.js'

export const COMMAND_CENTER_UPGRADE_TOOLTIP_ID = 'command_center.upgrade_tooltip'

export const COMMAND_CENTER_MODERNIZATION_PLAN_DESCRIPTION = (level) => (
    <FormattedMessage
        id='command_center.modernization_plan.description'
        defaultMessage={'Позволяет модернизировать все строения до {level} уровня.'}
        values={{ level }}
    />
)

export const COMMAND_CENTER_REWARDS_TITLE = (level) => (
    <FormattedMessage
        id='command_center.rewards.title'
        defaultMessage={'Награда за модернизацию командного центра до {level} уровня'}
        values={{ level }}
    />
)

export const RESERVE_TYPES_ORDER = [
    RESERVE_TYPES.MILITARY_MANEUVERS,
    RESERVE_TYPES.ADDITIONAL_BRIEFING,
    RESERVE_TYPES.BATTLE_PAYMENTS,
    RESERVE_TYPES.TACTICAL_TRAINING,
    RESERVE_TYPES.ARTILLERY_STRIKE,
    RESERVE_TYPES.INSPIRATION,
    RESERVE_TYPES.REQUISITION,
    RESERVE_TYPES.HIGH_CAPACITY_TRANSPORT,
]

export const MINIMUM_POSSIBLE_RESERVE_LEVEL = 3



// WEBPACK FOOTER //
// ./containers/CommandCenterCard/constants.jsx